(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MdaOfferCore = api;
})(typeof self !== 'undefined' ? self : this, function () {
  const UNLOCK_KEY = 'mda-hol26-nc';
  const CODE_LIMIT = 5;

  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (cents % 100 === 0 ? String(dollars) : dollars.toFixed(2));
  }

  function saveUnlock(storage, unlock) {
    try {
      storage.setItem(UNLOCK_KEY, JSON.stringify({ email: unlock.email, codes: unlock.codes, end: unlock.end }));
    } catch (e) {}
  }

  function readUnlock(storage, now) {
    try {
      const raw = storage.getItem(UNLOCK_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || typeof data.email !== 'string' || typeof data.end !== 'string') return null;
      if (!data.codes || typeof data.codes !== 'object') return null;
      if (now > data.end) return null;
      return { email: data.email, codes: data.codes, end: data.end };
    } catch (e) {
      return null;
    }
  }

  function clearUnlock(storage) {
    try {
      storage.removeItem(UNLOCK_KEY);
    } catch (e) {}
  }

  function codesForCart(handles, existing, ncCodes) {
    const ncSet = new Set(Object.keys(ncCodes).map((h) => ncCodes[h]));
    const out = [];
    const add = (code) => {
      if (code && out.indexOf(code) === -1) out.push(code);
    };
    handles.forEach((h) => {
      if (Object.prototype.hasOwnProperty.call(ncCodes, h)) add(ncCodes[h]);
    });
    existing.forEach((code) => {
      if (!ncSet.has(code)) add(code);
    });
    return out.slice(0, CODE_LIMIT);
  }

  function appliedCodes(cart) {
    const out = [];
    ((cart && cart.discount_codes) || []).forEach((d) => {
      if (d && typeof d.code === 'string' && d.code && out.indexOf(d.code) === -1) out.push(d.code);
    });
    return out;
  }

  function sameCodes(a, b) {
    return a.length === b.length && a.every((c) => b.indexOf(c) !== -1);
  }

  function pageState(unlock, returning) {
    if (unlock) return 'new';
    return returning ? 'returning' : 'locked';
  }

  return { UNLOCK_KEY, formatMoney, saveUnlock, readUnlock, clearUnlock, codesForCart, appliedCodes, sameCodes, pageState };
});
